angular.module('TurneroApp').component('coMotivosAlta', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlPadre: '='
    },
    controller: [
        'motivosService',
        'utilsService',
        'TurneroAppConstant',
        function (motivosService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.motivoAlta = {};

            ctrl.errores = {
                Tipo_Motivo: false,
                N_Motivo: false,
            };

            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoadAlta = function () {
                    ctrl.rolAlta = {};

                    ctrl.errores = {
                        Tipo_Motivo: false,
                        N_Motivo: false,
                    };

                    motivosService.get().$promise.then(function (res) {
                        ctrl.motivoAlta = res
                        ctrl.motivoAlta.Id_Tipo_Motivo = null;
                    }).catch(function (req) {
                        utilsService.errores(req);
                    });
                }
            }

            ctrl.guardarMotivoNuevo = function () {
                ctrl.errores.N_Motivo = !(ctrl.motivoAlta.N_Motivo);
                ctrl.errores.Tipo_Motivo = !(ctrl.motivoAlta.Id_Tipo_Motivo);

                if (ctrl.errores.N_Motivo || ctrl.errores.Tipo_Motivo) {
                    return
                };

                motivosService.save(ctrl.motivoAlta).$promise.then(function (res) {
                    ctrl.ctrlPadre.grillaReload();
                    sweetAlert("Alta Motivo", "El motivo se registró correctamente", "success");
                }).catch(function (req) {
                    utilsService.errores(req);
                });
            };

            ctrl.cancelar = function () {
                ctrl.ctrlPadre.grillaReload();
            }
        }
    ],
    template: require('./motivosAlta.html')
});


// WEBPACK FOOTER //
// ./app/components/motivos/motivosAltaComponent.js